import { render } from "./UserInfoButton.vue?vue&type=template&id=197cbd60&scoped=true&ts=true"
import script from "./UserInfoButton.vue?vue&type=script&lang=ts"
export * from "./UserInfoButton.vue?vue&type=script&lang=ts"

import "./UserInfoButton.vue?vue&type=style&index=0&id=197cbd60&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197cbd60"]])

export default __exports__